/**
 * Calculates the number of nights between two dates, handling daylight saving time correctly.
 * For accommodation booking, a night is counted as the difference in calendar days,
 * regardless of the actual hours due to DST transitions.
 *
 * @param startDate - Check-in date
 * @param endDate - Check-out date
 * @returns Number of nights (calendar days difference)
 */
export const calculateNights = (startDate: Date | string, endDate: Date | string): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Reset time components to avoid DST issues
  const startUTC = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endUTC = new Date(end.getFullYear(), end.getMonth(), end.getDate());

  // Calculate difference in milliseconds and convert to days
  const diffTime = endUTC.getTime() - startUTC.getTime();
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  return Math.max(0, diffDays);
};
